
import Vue from 'vue'

export default Vue.extend({
  props: {
    'value': Boolean,
    'title': String,
    'text': String,
    'positiveLabel': String,
    'negativeLabel': String,
  },
  methods: {
    positive() {
      this.$emit('input', false)
      this.$emit('positive')
    },
    neutral() {
      this.$emit('input', false)
      this.$emit('neutral')
    },
    negative() {
      this.$emit('input', false)
      this.$emit('negative')
    },
  },
  computed: {
    negativeButtonLabel(): string {
      return this.negativeLabel || this.$t('action.cancel') as string
    },
    positiveButtonLabel(): string {
      return this.positiveLabel || this.$t('action.confirm') as string
    },
  },
})
